import { Flex, Box } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Outlet } from 'react-router-dom';

import Button from 'components/Button';
import { TabHeader, RouterTabs } from 'components/Tabs';
import FEATURES from 'global/features';
import { roles } from 'global/rolesAndPermissions';
import { routePaths } from 'global/routePaths';
import { useFetchTabItemCountByModule } from 'hooks/common/useFetchTabItemCountsByModule';
import { useFeatureList } from 'store/useFeatureStore';
import { useUserObject } from 'store/useUserStore';

import All from './All';

const TimesheetMileageTabs: React.FC<unknown> = () => {
  const { t } = useTranslation(['common', 'timesheetMileage']);

  const navigate = useNavigate();
  const userStore = useUserObject();
  const featureList: any = useFeatureList();

  const [tabHeaders, setTabHeaders] = useState<any>([
    { label: t('common:pending'), pathname: routePaths.timesheetAndMileage.pending },
    { label: t('common:approved'), pathname: routePaths.timesheetAndMileage.approved },
  ]);

  const { data } = useFetchTabItemCountByModule('timesheet');

  useEffect(() => {
    if (data) {
      const { unapproved, approved } = data?.payload;

      const updatedTabHeaders = [
        { label: t('common:pending'), count: unapproved, pathname: routePaths.timesheetAndMileage.pending },
        { label: t('common:approved'), count: approved, pathname: routePaths.timesheetAndMileage.approved },
      ];
      setTabHeaders(updatedTabHeaders);
    }
  }, [data, t]);

  // Display only for user having employee role
  if (userStore?.userInfo?.roleId === roles.EMPLOYEE)
    return (
      <Box>
        {/* Only users having manageTimesheets permission can access this */}
        {userStore?.permissions?.manageTimesheets ? (
          <Flex justifyContent="flex-end">
            <Button
              colorScheme="secondary"
              mt={{ base: '5', md: '0' }}
              onClick={() => navigate(routePaths.timesheetAndMileage.addTimesheet.route)}
            >
              {t('timesheetMileage:addTimesheet')}
            </Button>
          </Flex>
        ) : null}

        <All />
      </Box>
    );

  return (
    <RouterTabs tabHeaders={tabHeaders}>
      <Flex justifyContent="space-between" flexDirection={{ base: 'column', md: 'row' }} mb="6">
        <TabHeader tabHeaders={tabHeaders} />
        <Flex ml="auto">
          {/* Only an admin with job features enabled, 
          OR a manager with both the 'manageTimesheet' permission and job features enabled, can access this button. */}
          {featureList[FEATURES.jobs] &&
          (userStore?.userInfo?.roleId === roles.ADMIN || userStore?.permissions?.manageTimesheets) ? (
            <Button
              bg="secondary.50"
              color="secondary.400"
              _hover={{
                bg: 'secondary.100',
              }}
              _active={{
                bg: 'secondary.100',
              }}
              mt={{ base: '5', md: '0' }}
              mr="4"
              onClick={() => navigate(routePaths.timesheetAndMileage.quickTimeEntry)}
            >
              {t('timesheetMileage:quickTimeClock')}
            </Button>
          ) : null}

          {/* Only an admin, 
          OR a manager with the 'manageTimesheet' permission can access this button. */}
          {userStore?.userInfo?.roleId === roles.ADMIN || userStore?.permissions?.manageTimesheets ? (
            <Button
              colorScheme="secondary"
              mt={{ base: '5', md: '0' }}
              onClick={() => navigate(routePaths.timesheetAndMileage.addTimesheet.route)}
            >
              {t('timesheetMileage:addTimesheet')}
            </Button>
          ) : null}
        </Flex>
      </Flex>

      <Outlet />
    </RouterTabs>
  );
};

export default TimesheetMileageTabs;
